"use client";

import React, { createContext, useContext, useState, ReactNode } from "react";

interface SupportChatOpenContextType {
  open: boolean;
  setOpen: (open: boolean) => void;
}

const SupportChatOpenContext = createContext<SupportChatOpenContextType | undefined>(undefined);

interface SupportChatOpenProviderProps {
  children: ReactNode;
}

export function SupportChatOpenProvider({ children }: SupportChatOpenProviderProps) {
  const [open, setOpen] = useState(false);

  return (
    <SupportChatOpenContext.Provider value={{ open, setOpen }}>
      {children}
    </SupportChatOpenContext.Provider>
  );
}

export function useSupportChatOpen(): SupportChatOpenContextType {
  const context = useContext(SupportChatOpenContext);
  if (!context) {
    throw new Error("useSupportChatOpen must be used within a SupportChatOpenProvider");
  }
  return context;
}

export function useSupportChatOpenOptional(): SupportChatOpenContextType | undefined {
  return useContext(SupportChatOpenContext);
}
